import React, { useCallback, useEffect, useState } from 'react'
import { getRecaptchaApiKey } from 'constants/api'
import { GoogleReCaptchaProvider, useGoogleReCaptcha } from 'react-google-recaptcha-v3'

export const withRecaptcha = Component => props => {
  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={getRecaptchaApiKey()}
      useEnterprise={true}
      container={{ element: 'grecaptcha', parameters: { badge: 'bottomright' } }}
    >
      <Component {...props} />
      <div id='grecaptcha' style={{ visibility: 'hidden' }}></div>
    </GoogleReCaptchaProvider>
  )
}

export const useRecaptcha = () => {
  const { executeRecaptcha } = useGoogleReCaptcha()
  const [isRecaptchaReady, setIsRecaptchaReady] = useState(false)
  const [isRequestingToken, setIsRequestingToken] = useState(false)
  const [error, setError] = useState<null | Error>(null)

  const getRecaptchaToken = useCallback(async () => {
    let token = ''
    try {
      setIsRequestingToken(true)
      if (executeRecaptcha) {
        token = await executeRecaptcha()
      } else {
        throw new Error('Recaptcha not ready')
      }
    } catch (e) {
      const error = e as Error
      error.message = `Failed to fetch Recaptcha token: ${error?.message}`
      console.warn(error.message)
      setError(error)
    } finally {
      setIsRequestingToken(false)
      return token
    }
  }, [executeRecaptcha])

  useEffect(() => {
    if (executeRecaptcha) setIsRecaptchaReady(true)
  }, [executeRecaptcha])

  return {
    isRecaptchaReady,
    isRequestingToken,
    error,
    getRecaptchaToken,
  }
}
